/**
 * Inline-editing toggle. The Topbar renders a Mantine Switch bound to
 * this context; routes (TableView) read `enabled` to enable Mantine
 * React Table's cell-level editing.
 */
import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

type Ctx = {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
};

const InlineEditingContext = createContext<Ctx>({
  enabled: false,
  setEnabled: () => {},
});

export function InlineEditingProvider({ children }: { children: ReactNode }) {
  const [enabled, setEnabled] = useState(false);
  const value = useMemo(() => ({ enabled, setEnabled }), [enabled]);
  return (
    <InlineEditingContext.Provider value={value}>
      {children}
    </InlineEditingContext.Provider>
  );
}

export function useInlineEditing() {
  return useContext(InlineEditingContext);
}
